import { useTier } from './useTier'

/**
 * The single source of truth for the mobile/desktop fork.
 * true below 768px (the phone tier), false at tablet+ — EXACT prior semantics.
 * Derived from useTier() (A6 §4.2); never introduce ad-hoc useMediaQuery for this decision.
 */
export function useIsMobile(): boolean {
  return useTier() === 'phone'
}
